module.exports = "/images/milano-2.jpg";